import React, { Component } from "react";
import Button from "react-bootstrap/Button";
import Dropdown from "react-bootstrap/Dropdown";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDoorOpen } from "@fortawesome/free-solid-svg-icons";
import { faBell } from "@fortawesome/free-solid-svg-icons";
import { connect } from "react-redux";
import {
  getDeviceAlarmCount,
  getDeviceOkCount,
  getOpenDoorCount,
  getDeviceLocations,
} from "./selectors/deviceListSelector";
import {
  filterByStatus,
  filterByAlarm,
  filterByOk,
  searchByValue,
  filterByDoor,
  filterByFavourite,
  clearFilter,
  filterByLocation,
} from "./actions/deviceListActions";
import DeviceListGroupFilterDropdown from "./DeviceListGroupFilterDropdown";
class DeviceListFilters extends Component {
  renderDropDownItem(location, index) {
    return (
      <Dropdown.Item
        as="button"
        onClick={() => this.props.filterByLocation(location)}
        key={index}
      >
        {location}
      </Dropdown.Item>
    );
  }

  renderLocationDropdown() {
    let dropdown;
    dropdown = (
      <>
        <Dropdown.Toggle variant="info" id="dropdown-basic">
          Location
        </Dropdown.Toggle>{" "}
        <Dropdown.Menu>
          {this.props.deviceLocations.map((location, index) =>
            this.renderDropDownItem(location, index)
          )}
        </Dropdown.Menu>
      </>
    );
    return dropdown;
  }

  render() {
    return (
      <div className="list-group-filter-button-container">
        <Dropdown>
          <Button variant="danger" onClick={() => this.props.filterByAlarm()}>
            <FontAwesomeIcon icon={faBell} /> {this.props.deviceAlarmCount}
          </Button>{" "}
          <Button
            variant="danger"
            onClick={() => this.props.filterByDoor(true)}
          >
            <FontAwesomeIcon icon={faDoorOpen} />
            {this.props.deviceOpenDoorCount}
          </Button>{" "}
          <Button variant="success" onClick={() => this.props.filterByOk()}>
            {this.props.deviceOkCount}
          </Button>{" "}
          {/* {this.renderLocationDropdown()} */}
          <DeviceListGroupFilterDropdown />
          <Button variant="secondary" onClick={() => this.props.clearFilter()}>
            All
          </Button>{" "}
          <Button variant="info" onClick={() => this.props.filterByFavourite()}>
            Fav
          </Button>
        </Dropdown>
      </div>
    );
  }
}

function mapStateToProps(state, ownProps) {
  return {
    deviceAlarmCount: getDeviceAlarmCount(state),
    deviceOkCount: getDeviceOkCount(state),
    deviceOpenDoorCount: getOpenDoorCount(state),
    deviceLocations: getDeviceLocations(state),
  };
}

const mapDispatchToProps = {
  filterByStatus,
  filterByAlarm,
  filterByOk,
  searchByValue,
  filterByDoor,
  filterByFavourite,
  clearFilter,
  filterByLocation,
};

export default connect(mapStateToProps, mapDispatchToProps)(DeviceListFilters);
